// RMS energy below this is treated as silence (matches legacy audioBuffer.ts).
export const SILENCE_RMS_THRESHOLD = 0.01;
// Keep transmitting for this long after the last sound, to capture word tails.
export const SILENCE_HANGOVER_MS = 1500;
// Amount of audio retained while silent so a resuming word's onset isn't clipped.
export const PREROLL_MS = 300;
// Warn when no sound at all has been heard since recording started (dead/muted mic).
export const NO_INPUT_WARN_MS = 10 * 1000;
// Warn after this much continuous silence.
export const AUTO_STOP_SILENCE_MS = 15 * 60 * 1000;
// Auto-pause this long after the warning unless sound resumes.
export const AUTO_STOP_COUNTDOWN_MS = 30 * 1000;

/** Root-mean-square energy of a Float32 audio frame. 0 for an empty frame. */
export const computeFrameRms = (frame: Float32Array): number => {
  if (frame.length === 0) return 0;
  let sum = 0;
  for (let i = 0; i < frame.length; i++) {
    sum += frame[i] * frame[i];
  }
  return Math.sqrt(sum / frame.length);
};

/** RMS energy of an Int16 PCM frame, normalized to [0,1]. 0 for an empty frame. */
export const computeInt16Rms = (frame: Int16Array): number => {
  if (frame.length === 0) return 0;
  let sumSq = 0;
  for (let i = 0; i < frame.length; i++) {
    const v = frame[i] / 0x8000;
    sumSq += v * v;
  }
  return Math.sqrt(sumSq / frame.length);
};

/**
 * Whether the live stream should transmit now. True while sound is present or
 * within the hangover window after the last sound; false during true silence.
 */
export const shouldTransmit = (now: number, lastSoundTime: number): boolean => {
  if (lastSoundTime <= 0) return false;
  return now - lastSoundTime < SILENCE_HANGOVER_MS;
};
